module.exports = __webpack_public_path__ + "static/media/108.8338ba6d.jpg";